module.exports = __webpack_public_path__ + "img/UntermWasserfall.8aef0b72.jpg";